// extracted by mini-css-extract-plugin
export default {"notification":"single-cube_pages_home_yeehaw_device_notification","rightRail":"single-cube_pages_home_yeehaw_device_rightRail"};